import * as yup from 'yup';
import svStrings from '../../../sv-strings';
import { FIELD_TYPES, UIschema } from '../../../types';
import { Article } from './types';

export const getEditArticleSchema = (article?: Article): UIschema => ({
  name: 'Edit article',
  fields: [
    {
      id: 'sortIndex',
      type: FIELD_TYPES.NUMBER,
      key: 'sortIndex',
      value: article?.sortIndex,
      title: svStrings.faq.fieldNameSortIndex,
      validation: yup.number().nullable(),
      helperText: svStrings.faq.sortIndexHelperText,
    },
    {
      id: 'slug',
      type: FIELD_TYPES.TEXT,
      key: 'slug',
      value: article?.slug,
      title: svStrings.faq.fieldNameSlug,
      validation: yup.string().required(svStrings.faq.slugFieldRequired),
    },
    {
      id: 'title',
      type: FIELD_TYPES.TEXT,
      key: 'title',
      value: article?.title,
      title: svStrings.faq.fieldNameTitle,
      validation: yup.string().required(svStrings.faq.titleFieldRequired),
    },
    {
      id: 'content',
      type: FIELD_TYPES.RICH_TEXT_HTML,
      key: 'content',
      value: article?.content,
      title: svStrings.faq.fieldNameHtml,
    },
  ],
});
